/** Convierte a número lo que llega de la API (puede venir como string,
 *  null o undefined). Devuelve null si no es un número utilizable. */
const toNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

/**
 * Formatea el PVP de un producto aplicando el tipo de cambio activo.
 *
 * Un producto tiene precio único cuando todas sus variantes valen lo
 * mismo (pvp_min === pvp_max) y rango cuando no. En el rango el símbolo
 * de moneda se escribe una sola vez, al final: "3.990,00 - 4.190,00 MXN".
 *
 * Devuelve null si el producto no tiene precio, para que quien llama
 * decida si oculta la etiqueta o pinta un placeholder.
 */
export const formatPvp = (pvpMin, pvpMax, currency) => {
  const symbol = currency?.symbol ?? 'MXN';
  const exchange = toNumber(currency?.exchange) ?? 1;

  const min = toNumber(pvpMin);
  const max = toNumber(pvpMax);
  if (min === null && max === null) return null;

  const low = (min ?? max) * exchange;
  const high = (max ?? min) * exchange;

  const money = new Intl.NumberFormat('es-ES', { style: 'currency', currency: symbol });
  if (low === high) return money.format(low);

  const plain = new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${plain.format(low)} - ${money.format(high)}`;
};

/** Descuento medio sobre el PVP original. null si no se puede calcular. */
export const formatDiscount = (pvpAvg, pvpMin) => {
  const avg = toNumber(pvpAvg);
  const base = toNumber(pvpMin);
  if (avg === null || !base) return null;

  return new Intl.NumberFormat('es-ES', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(1 - avg / base);
};
